function toPriceText(price) {
    const normalized = Number(price);
    if (Number.isFinite(normalized)) {
        return `${normalized}元/人`;
    }

    return '0元/人';
}

function buildNutritiousDiningOpenRows(openInfo) {
    if (!openInfo || !Array.isArray(openInfo.menuList)) {
        return [];
    }

    return openInfo.menuList
        .map((row) => {
            if (!row) {
                return null;
            }

            const dishName = String(row.dishName || '').trim();
            if (!dishName) {
                return null;
            }

            return {
                dishName,
                priceText: toPriceText(row.price),
            };
        })
        .filter(Boolean);
}

module.exports = {
    buildNutritiousDiningOpenRows,
};
